import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { COMMANDS } from "../../../mod-command/constants";
import { sendCommand } from "../../../mod-command/slice";
import { NOTIFICATION_TIMEOUT_TYPE, showNotification } from "../../../notifications";
import Dialog from "../../../base/ui/components/web/Dialog";
import { useTranslation } from "react-i18next";
const UnMuteAllDialog = ({ exclude, isModerationSupported, }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { password } = useSelector((state) => state["features/base/conference"]);
    const [title, setTitle] = useState(t("dialog.unMuteEveryoneElseTitle", { who: t("dialog.SIP") }));
    const [content, setContent] = useState(t("dialog.unMuteEveryoneElseDialogSIP"));
    // Handles the submit action for unmuting participants.
    const onSubmit = () => {
        dispatch(sendCommand(COMMANDS.MIC_SIP.COMMAND, COMMANDS.MIC_SIP.ON));
        dispatch(showNotification({ titleKey: t("notify.unMutedAllSIP") }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
        return true;
    };
    return (React.createElement(Dialog, { ok: { translationKey: "dialog.unmuteMic" }, onSubmit: onSubmit, title: title },
        React.createElement("div", { className: "mute-dialog" }, content)));
};
export default UnMuteAllDialog;
